import React, { useRef } from 'react';
import { Download, Upload } from 'lucide-react';
import { exportData, importData, generateShareableLink, importFromLink, clearAllData } from '../utils/dataExport';
import { DataModal } from './modals/DataModal';

interface DataControlsProps {
  onDataImported: () => void;
}

export function DataControls({ onDataImported }: DataControlsProps) {
  const [modalType, setModalType] = React.useState<'export' | 'import' | null>(null);

  const handleImportJson = async (file: File) => {
    try {
      await importData(file);
      onDataImported();
      alert('Data imported successfully!');
    } catch (error) {
      alert('Failed to import data. Please check the file format.');
    }
  };

  const handleImportLink = async (link: string) => {
    try {
      await importFromLink(link);
      onDataImported();
      alert('Data imported successfully!');
    } catch (error) {
      alert('Failed to import data. Please check the link format.');
    }
  };

  const handleExportJson = () => {
    try {
      exportData();
    } catch (error) {
      alert('Failed to export data.');
    }
  };

  const handleExportLink = () => {
    try {
      return generateShareableLink();
    } catch (error) {
      alert('Failed to generate link.');
      return '';
    }
  };

  const handleClearData = () => {
    if (window.confirm('Are you sure you want to clear all data? This action cannot be undone.')) {
      if (clearAllData()) {
        alert('All data has been cleared successfully.');
        window.location.reload();
      } else {
        alert('Failed to clear data. Please try again.');
      }
    }
  };

  const closeModal = () => {
    setModalType(null);
  };

  const handleImportFromLink = async () => {
    try {
      await importFromLink(linkInputValue);
      onDataImported();
      setShowLinkInput(false);
      setLinkInputValue('');
      alert('Data imported successfully!');
    } catch (error) {
      alert('Failed to import data. Please check the link format.');
    }
  };

  return (
    <>
      <div className="flex flex-col sm:flex-row gap-4 sm:gap-0 sm:justify-between sm:items-center">
        <button
          onClick={() => setModalType('export')}
          className="flex items-center gap-2 px-4 py-2 text-blue-600 border border-blue-300 
                   rounded-md hover:bg-blue-50 transition-colors w-full sm:w-auto
                   justify-center sm:justify-start"
        >
          <Download size={20} />
          Export Data
        </button>

        <button
          onClick={() => setModalType('import')}
          className="flex items-center gap-2 px-4 py-2 text-blue-600 border border-blue-300 
                   rounded-md hover:bg-blue-50 transition-colors w-full sm:w-auto
                   justify-center sm:justify-start"
        >
          <Upload size={20} />
          Import Data
        </button>
      </div>

      {modalType && (
        <DataModal
          isOpen={true}
          onClose={closeModal}
          type={modalType}
          onExportJson={handleExportJson}
          onExportLink={handleExportLink}
          onImportJson={handleImportJson}
          onImportLink={handleImportLink}
          onClearData={handleClearData}
        />
      )}
    </>
  );
}